import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/landing.css */
  &#immunefi_bug_bounty {
    width: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 1;
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.1);
  }
  &#immunefi_bug_bounty a {
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 30px 60px;
  }
  &#immunefi_bug_bounty a:hover {
    background: rgba(255, 255, 255, 0.05);
  }
  &#immunefi_bug_bounty .immunefi_logo {
    margin: 4px 0 0 0;
  }
  &#immunefi_bug_bounty .immunefi_logo img {
    width: 160px;
  }
  &#immunefi_bug_bounty .plus {
    font-size: 2.1rem;
    font-weight: 800;
    line-height: 100%;
    padding: 0 15px;
    margin: -2px 0 0 0;
  }
  &#immunefi_bug_bounty .yolo_bug_bounty_text {
    font-size: 1.4rem;
    font-weight: 500;
    letter-spacing: -0.03em;
  }
  @media (max-width: 600px) {
    &#immunefi_bug_bounty a {
      flex-flow: column;
    }
    &#immunefi_bug_bounty .plus {
      margin: -6px 0 0 0;
    }
  }
`

const developerCSS = css``

export const ImmuneFiSectionCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
